import { NavLink } from 'react-router-dom'
import type { NavItem as NavItemType } from '../../lib/navigation'
import { NavIcon } from './NavIcon'

interface NavItemProps {
  item: NavItemType
}

export function NavItem({ item }: NavItemProps) {
  return (
    <NavLink
      to={item.path}
      style={({ isActive }) => ({
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '8px 14px',
        margin: '1px 4px',
        borderRadius: 3,
        textDecoration: 'none',
        fontFamily: 'var(--font-body)',
        fontSize: 'var(--fs-body)',
        color: isActive ? 'hsl(var(--accent-foreground))' : 'hsl(var(--sidebar-foreground-soft))',
        background: isActive ? 'var(--sidebar-active, hsl(var(--accent)))' : 'transparent',
        transition: 'background 0.12s, color 0.12s',
      })}
    >
      {item.icon && <NavIcon name={item.icon} size={14} />}
      <span>{item.label}</span>
    </NavLink>
  )
}
